import { render, staticRenderFns } from "./CountriesCard.vue?vue&type=template&id=9f4b4220&scoped=true&"
import script from "./CountriesCard.vue?vue&type=script&lang=js&"
export * from "./CountriesCard.vue?vue&type=script&lang=js&"
import style0 from "./CountriesCard.vue?vue&type=style&index=0&id=9f4b4220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4b4220",
  null
  
)

export default component.exports